import { render, staticRenderFns } from "./MainTemplate.vue?vue&type=template&id=bd0590b8&scoped=true&"
import script from "./MainTemplate.vue?vue&type=script&lang=js&"
export * from "./MainTemplate.vue?vue&type=script&lang=js&"
import style0 from "./MainTemplate.vue?vue&type=style&index=0&id=bd0590b8&prod&lang=scss&scoped=true&"
import style1 from "./MainTemplate.vue?vue&type=style&index=1&id=bd0590b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0590b8",
  null
  
)

export default component.exports